import lumber from "./ads/lumber.svg";
import ai from "./ads/ai.svg";
import taxi from "./ads/taxi.svg";
import lawyer from "./ads/lawyer.svg";
import restaurant from "./ads/restaurant.svg";
import doctor from "./ads/doctor.svg";
import nurse from "./ads/nurse.svg";
import secretary from "./ads/secretary.svg";
import preschool from "./ads/preschool.svg";
import janitor from "./ads/janitor.svg";
import retail from "./ads/retail.svg";

const content = {
  Lumber: {
    img: lumber,
    header: "Strong Lumberjacks Needed!",
    subheader: "$15-$16 an hour - Full-time",
    link: "https://web.archive.org/web/20210330182930/https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=13073&clientkey=903B1FB3685BCA3E9784B31E6354DA9C",
    summary:
      "Supply our customers with innovative, quality, name-brand products from respected, environmentally conscious manufacturers.",
    reqs: "in position details",
    pay: "$15-$16 an hour",
  },
  AI: {
    img: ai,
    header: "AI/ML Engineers Needed!",
    subheader: "varies / negotiable - Full-time",
    link: "https://web.archive.org/web/20210320212422/https://waymo.com/joinus/2551515/",
    summary:
      "You will be working on all aspects of the modeling life cycle, put your models to work, and measure impact on the overall system.",
    reqs: "BS, MS, or Ph.D Computer Science",
    pay: "varies / negotiable",
  },
  Taxi: {
    img: taxi,
    header: "Taxi Drivers Needed!",
    subheader: "$20 an hour - Full-time, Part-time",
    link: "https://www.uber.com/us/en/drive/",
    summary:
      "Earn anytime, anywhere. Fit driving around what matters most. Drive at any time and on any day of the week.",
    reqs: "valid drivers license",
    pay: "$20 an hour",
  },
  Lawyer: {
    img: lawyer,
    header: "Lawyers Needed!",
    subheader: "varies / negotiable - Full-time",
    link: "https://web.archive.org/web/20210330184759/https://lawcruit.micronapps.com/sup/JobPostingDetails.aspx?lawfirm=MW4zNA%3D%3D&JobId=MW4lM2YzMGklM2Fh&at=OF9DRw%3D%3D",
    summary:
      "We are looking for a resource attorney to enable our practicing attorneys to be more informed and efficient.",
    reqs: "Bar License",
    pay: "varies / negotiable",
  },
  Restaurant: {
    img: restaurant,
    header: "Restaurant Servers Needed!",
    subheader: "$15 an hour - Full-time, Part-time",
    link: "https://web.archive.org/web/20210330192119/https://www.cakecareers.com/restaurant-management/jobs/2334?lang=en-us",
    summary:
      "We offer consistent hours, flexible schedules and the opportunity to make a great income!",
    reqs: "1+ year server experience",
    pay: "$15 an hour",
  },
  Doctor: {
    img: doctor,
    header: "Physicians Needed!",
    subheader: "varies / negotiable - Full-time",
    link: "https://web.archive.org/web/20210330223952/https://hcahealthcare.com/physicians/physician-careers.dot?facility=CareNow+-+Dallas+County&location=Dallas%2C+TX&specialty=Physician+Assistant+-+Urgent+Care&id=0062S00000zJxjsQAC",
    summary:
      "CareNow Urgent Care is seeking board certified physician assistants to work within our Dallas (North, Central, South), TX and surrounding area clinics.",
    reqs: "Board certified, 3+ years experience",
    pay: "varies / negotiable",
  },
  Nurse: {
    img: nurse,
    header: "Nurses Needed!",
    subheader: "varies / negotiable - Full-time",
    link: "https://web.archive.org/web/20210330215239/https://jobs.cvshealth.com/ShowJob/JobId/937299/LVNLicensedVocNurseBedfordTX?prefilters=none&CloudSearchLocation=none&CloudSearchValue=none",
    summary:
      "We are looking for nurses to assist patients and perform/assist  with all clinical services available at the clinics.",
    reqs: "Licensed Practical or Vocational Nurse",
    pay: "varies / negotiable",
  },
  Secretary: {
    img: secretary,
    header: "Secretary Needed!",
    subheader: "$43K-$62K a year - Full-time",
    link: "https://web.archive.org/web/20210330193940/https://www.usajobs.gov/GetJob/ViewDetails/596200500",
    summary:
      "Provide staff and assistant support to the Bureau Chief Procurement Officer  on a wide range of issues!",
    reqs: "GS-06/07 federal experience",
    pay: "$43K-$62K a year",
  },
  Preschool: {
    img: preschool,
    header: "Preschool Teachers Needed!",
    subheader: "varies / negotiable - Full-time",
    link: "https://metrokidspreschool.com/careers/",
    summary:
      "We need help at our shop in Kennesaw. Must be able to lift over 50 lbs and work outside.",
    reqs: "New York State certified",
    pay: "varies / negotiable",
  },
  Janitor: {
    img: janitor,
    header: "Janitors Needed!",
    subheader: "$12 an hour - Full-time",
    link: "https://web.archive.org/web/20210330183644/https://jobs.aerotek.com/us/en/job/JP-002056439/Janitor",
    summary:
      "We are hiring a Shop Helper to take care of their facilities and carry out cleaning and very basic maintenance duties.",
    reqs: "janatorial experience",
    pay: "$12 an hour",
  },
  Retail: {
    img: retail,
    header: "Retail Workers Needed!",
    subheader: "$15-$17 an hour - Full Time",
    link: "https://web.archive.org/web/20210330182053/https://traderjoes.avature.net/careers/JobDetail/United-States-Crew/8564",
    summary:
      "If you have a passion for people and a fervor for food, we'd love to meet you.  We can teach you the rest.",
    reqs: "in position details",
    pay: "$15-$17 an hour",
  },
};

export default content;
